module.exports = __webpack_public_path__ + "img/p1-m.17e5f0c7.jpg";